import { run, wrap } from './lib'

export { isClient, isPcClient, isMacClient, isLinuxClient } from './lib'

/**
 * 获取版本号
 *
 * @returns result 版本号字符串
 *          digits 版本号数字部分
 */
export const getVersion = wrap({ minVer: '*' }, async () => {
  const originResult = await run({
    action: 'GetVersion',
  })
  const data = JSON.parse(originResult)
  const v = data.version
  const digits = v.match(/\d+.\d+.\d+.\d+/) && v.match(/\d+.\d+.\d+.\d+/)[0]
  return {
    originResult,
    result: v,
    digits,
  }
})

/**
 * 刷新页面
 */
export const reloadMainPage = wrap({ minVer: '*' }, async () => {
  const originResult = await run({
    action: 'ReloadMainPage',
  })
  return {
    originResult,
  }
})

/**
 * @deprecated 客户端内已失效
 */
export const writeLog = wrap({ minVer: '*' }, async content => {
  const originResult = await run({
    action: 'WriteLog',
    params: content,
  })
  return {
    originResult,
  }
})

/**
 * 读取客户端本地数据
 *
 * @param key 数据对象
 */
export const readFromLocal = wrap({ minVer: '*' }, async key => {
  const originResult = await run({
    action: 'readFromLocal',
    params: JSON.stringify({ key }),
  })
  return {
    originResult,
  }
})

/**
 * 保存数据到客户端本地
 *
 * @param data 数据对象
 */
export const saveToLocal = wrap({ minVer: '*' }, async data => {
  const originResult = await run({
    action: 'saveToLocal',
    params: JSON.stringify(data),
  })
  return {
    originResult,
  }
})

/**
 * 创建同步
 *
 * @param {string} path 路径
 * @param {string} neid 元数据ID
 * @param {string} isShared 是否共享
 * @param {string} dirType 目录类型
 * @param {string} bookmarkId 收藏表主键id
 * @param {string} from 共享者的 uid
 * @param {string} nsid 命名空间ID
 * @param {string} pathType 路径类型
 * @param {string} accessMode 权限码
 * @param {string} prefixNeid 前缀neid
 */
export const createSync = wrap(
  { minVer: '*' },
  async ({
    path,
    neid,
    isShared,
    dirType,
    bookmarkId,
    from,
    nsid,
    pathType,
    accessMode,
    prefixNeid,
  }) => {
    const originResult = await run({
      action: 'CreateSync',
      params: JSON.stringify({
        remotePath: {
          path,
          neid,
          is_shared: isShared,
          dir_type: dirType,
          bookmark_id: bookmarkId,
          from,
          nsid,
          path_type: pathType,
          access_mode: accessMode,
          prefix_neid: prefixNeid,
        },
      }),
    })
    return {
      originResult,
    }
  },
)

/*
 * 告知桌面端调用js接口后的返回值
 *
 * @param {string} funcName 执行的js方法
 * @param {string} funcParam js方法的返回值
 */
export const jsFuncResult = wrap({ minVer: '*' }, async ({ funcName, funcParam }) => {
  const originResult = await run({
    action: 'JSFuncResult',
    params: JSON.stringify({
      funcnam: funcName,
      funcparam: funcParam,
    }),
  })
  return {
    originResult,
  }
})

/**
 * 结束拖拽
 */
export const startDrop = wrap({ minVer: '*' }, async () => {
  const originResult = await run({
    action: 'StartDrop',
  })
  return {
    originResult,
  }
})

/*
 * 设置当前目录信息
 *
 * @param {Object} remotePath 前所在目录完整信息
 * @param {Object} host 融合云数据中心信息 id  -数据中心id domain - 数据中心地址
 */
export const setCurrentPath = wrap({ minVer: '*' }, async ({ remotePath, host }) => {
  const originResult = await run({
    action: 'SetCurrentPath',
    params: JSON.stringify({
      remotePath,
      host,
    }),
  })
  return {
    originResult,
  }
})

/**
 * 设置退出时账号状态信息
 * @param {Object} data 任何需要存储的信息，客户端存储到本地文件，不做定向要求
 */
export const setExitInfo = wrap({ minVer: '*' }, async data => {
  const originResult = await run({
    action: 'SetExitInfo',
    params: JSON.stringify(data),
  })
  return {
    originResult,
  }
})

/**
 * 打开本地同步窗口
 */
export const showSyncWnd = wrap({ minVer: '*' }, async () => {
  const originResult = await run({
    action: 'ShowSyncWnd',
  })
  return {
    originResult,
  }
})

/**
 * 设置选中文件信息
 *
 * @param {array} data 选中的文件信息集合
 */
export const setSelectedPaths = wrap({ minVer: '*' }, async data => {
  const originResult = await run({
    action: 'SetSelectedPaths',
    params: JSON.stringify({
      remotePaths: data,
    }),
  })
  return {
    originResult,
  }
})

/**
 * 判断客户端是否全屏
 */
export const wndIsFullScreen = wrap({ minVer: '*' }, async () => {
  const originResult = await run({
    action: 'WndIsFullScreen',
  })
  return {
    originResult,
  }
})

/**
 * 下载文件
 *
 * @param {array} remotePaths 要下载文件的文件信息集合
 * @param {string} downloadpath 文件要下载到的本地目录，如果这个参数为空则客户端弹框让用户自己选择下载路径
 */
export const downloadFile = wrap({ minVer: '*' }, async ({ remotePaths, downloadpath }) => {
  const originResult = await run({
    action: 'DownloadFile',
    params: JSON.stringify({
      remotePaths,
      downloadpath,
    }),
  })
  return {
    originResult,
  }
})

/**
 * 判断客户端是否开始拖拽
 */
export const startDrag = wrap({ minVer: '*' }, async () => {
  const originResult = await run({
    action: 'StartDrag',
  })
  return {
    originResult,
  }
})

/**
 * 启动本地编辑
 *
 * @param {Object} data 选中文件的文件节点信息
 */
export const localEdit = wrap({ minVer: '*' }, async data => {
  const originResult = await run({
    action: 'LocalEdit',
    params: JSON.stringify({ remotePath: data }),
  })
  return {
    originResult,
  }
})

/**
 * 页面处理鼠标键盘消息
 *
 * @param {string} key  key的值 Ctrl+c    0
                               Ctrl+v    1
                               Ctrl+x    2
                               Ctrl+s    3
 *@param {string} neid  当前操作所在id
 */
export const webKeyEvent = wrap({ minVer: '*' }, async ({ key, neid }) => {
  const originResult = await run({
    action: 'WebKeyEvent',
    params: JSON.stringify({
      key,
      remotePath: {
        neid,
      },
    }),
  })
  return {
    originResult,
  }
})

/**
 * 加载上次退出时账号信息
 *
 */
export const loadLastQuitInfo = wrap({ minVer: '*' }, async () => {
  const originResult = await run({
    action: 'LoadLastQuitInfo',
  })
  return {
    originResult,
  }
})

/*
 * 打开客户端内部窗口
 *
 * @param {string} url 窗口中显示页面的链接
 * @param {number} width 窗口的宽度 不填则使用客户端默认宽度
 * @param {number} height 窗口的高度，不填则使用客户端默认高度
 * @param {boolean} fullscreen 是否全屏显示，不填则正常大小显示
 * @param {string} title 窗口标题名称
 */
export const openUrlInside = wrap(
  { minVer: '*' },
  async ({ url, width, height, fullscreen, title }) => {
    const originResult = await run({
      action: 'OpenUrlInside',
      params: JSON.stringify({
        url,
        width,
        height,
        fullscreen,
        title,
      }),
    })
    return {
      originResult,
    }
  },
)

/**
 * 上传接口
 *
 * @param {Object} remotePath 代表文件或文件夹要上传到网盘上的位置信息，即文件夹的matadata信息
 * @param {Array}  localPaths 代表要上传的文件路径集合，当不传此参数时，调用此接口客户端会弹出文件选择窗口，由用户选择文件上传；
 */
export const uploadFile = wrap({ minVer: '*' }, async ({ remotePath, localPaths }) => {
  const originResult = await run({
    action: 'UploadFile',
    params: JSON.stringify({
      remotePath,
      localPaths,
    }),
  })
  return {
    originResult,
  }
})

/**
 * 控制客户端窗口接口
 *
 * @param {string} wndName ------窗口名称-例如标题栏窗口：MainWndTitle
 * @param {string} operate --------对窗口的操作类型-例如，显示或隐藏使用show和hide，关闭使用close，最大化max，最小化min，显示到最上层top
 */
export const controlClientWnd = wrap({ minVer: '*' }, async ({ wndName, operate }) => {
  const originResult = await run({
    action: 'ControlClientWnd',
    params: JSON.stringify({
      WndName: wndName,
      Operate: operate,
    }),
  })
  return {
    originResult,
  }
})

/**
 * 打开外部浏览器窗口
 *
 * @param {string} url 要在浏览器中显示的页面链接
 * @param {boolean} useSession 跳转时是否带上session，如果是true 则调用jump接口跳转，如果是false，则直接通过浏览器打开
 * @param {booloean} useIe 如果use_session是true则这个参数无用，如果是false，参数useIe起作用，如果useIe为true则使用ie浏览器打开，如果是false则使用当前默认浏览器打开
 */
export const openUrlOutside = wrap({ minVer: '*' }, async ({ url, useSession, useIe }) => {
  const originResult = await run({
    action: 'OpenUrlOutside',
    params: JSON.stringify({
      url,
      use_session: useSession,
      use_ie: useIe,
    }),
  })
  return {
    originResult,
  }
})

/**
 * 设置搜索关键字
 *
 * @param {string} key 要搜索的关键字
 */
export const setSearchKey = wrap({ minVer: '*' }, async ({ key }) => {
  const originResult = await run({
    action: 'SetSearchKey',
    params: JSON.stringify({ key }),
  })
  return {
    originResult,
  }
})

/**
 * 注销登录
 *
 * @param  logout_type    调用退出类型，可填类型如下
 *                        注销调用           quit
 *                        session过期调用    invalidsession
 */
export const loginOut = wrap({ minVer: '*' }, async data => {
  const originResult = await run({
    action: 'LoginOut',
    params: JSON.stringify(data),
  })
  return {
    originResult,
  }
})

/*
 * 通知客户端文件夹被成功删除
 *
 * @param {array} data 删除的文件数据集合
 */
export const remoteFileDeletionSucc = wrap({ minVer: '*' }, async data => {
  const originResult = await run({
    action: 'RemoteFileDeletionSucc',
    params: JSON.stringify({ folderList: data }),
  })
  return {
    originResult,
  }
})

/**
 * 打印接口
 *
 * @param {string} url 获取预览文档数据接口
 */
export const printDoc = wrap({ minVer: '*' }, async ({ url }) => {
  const originResult = await run({
    action: 'PrintDoc',
    params: JSON.stringify({ url }),
  })
  return {
    originResult,
  }
})

/**
 * 最大化窗口
 *
 * @param {boolean} fullscreen 取值 true 全屏    false 取消全屏
 */
export const fullscreenWnd = wrap({ minVer: '*' }, async ({ fullscreen }) => {
  const originResult = await run({
    action: 'FullscreenWnd',
    params: JSON.stringify({ fullscreen }),
  })
  return {
    originResult,
  }
})

/**
 * 打开传输列表窗口
 *
 */
export const showTransWnd = wrap({ minVer: '*' }, async () => {
  const originResult = await run({
    action: 'ShowTransWnd',
  })
  return {
    originResult,
  }
})

/**
 * 外链文件下载
 *
 * @param {Array} fileLinks 参数为url数组
 * @param {Array}  FileEntries 支持文件夹文件分批处理下载调用方式（5.1.1版本后支持）  对应值为下载文件的对象数组，对象中对应的参数path-压缩包内下载文件的路径，size-文件大小,isdir-是否是文件夹，download_url-文件下载的链接地址，如果是文件夹这个参数可以为空或者不传,password-如果压缩包有密码则需要传密码，没有传空
 * @param {boolean}  hasMore -标识此次下载是否调用完成，如果用户勾选的压缩包文件数量多的情况下，页面调用客户端下载接口时每100条调用一次此时has_more传true，在调用最后一次has_more传false，如果下载文件不足100条has_more直接传false
 */
export const linkFileDownload = wrap(
  { minVer: '*' },
  async ({ fileLinks, FileEntries, hasMore }) => {
    const data = fileLinks ? { fileLinks } : { FileEntries, hasMore }
    const originResult = await run({
      action: 'LinkFileDownload',
      params: JSON.stringify(data),
    })
    return {
      originResult,
    }
  },
)

/**
 * 通知客户端更新用户信息
 */
export const userInfoChanged = wrap({ minVer: '*' }, async () => {
  const originResult = await run({
    action: 'UserInfoChanged',
  })
  return {
    originResult,
  }
})

/**
 * 保存登录信息
 * @param {string} name 用户名，字段为空时，将不会记录此次登录信息
 * @param {string} pass 用户密码，可以为空
 * @param {boolean} autoLogin 是否是自动登录
 * @param {boolean} bindType 是否是ad认证登录
 * @param {string} loginType 记录当前登录的是登录类型，企业登录传 ent，普通账号登录传 pwd
 */
export const saveLoginInfo = wrap(
  { minVer: '*' },
  async ({ name, pass, autoLogin, bindType, loginType }) => {
    const originResult = await run({
      action: 'SaveLoginInfo',
      params: JSON.stringify({
        name,
        pass,
        auto_login: autoLogin,
        bind_type: bindType,
        login_type: loginType,
      }),
    })
    return {
      originResult,
    }
  },
)

/**
 * 复制到剪贴板
 * @param {string} text 要复制到剪贴板中的纯文本信息
 * @param {string} html 要复制到剪贴板中的超文本信息
 * @param {string} picture 要复制到剪贴板中的图片信息，图片数据是base64格式的
 */
export const setClipboard = wrap({ minVer: '*' }, async ({ text, html, picture }) => {
  const originResult = await run({
    action: 'SetClipboard',
    params: JSON.stringify({ text, html, picture }),
  })
  return {
    originResult,
  }
})

/**
 * 关闭客户端当前窗口
 */
export const closeWnd = wrap({ minVer: '*' }, async () => {
  const originResult = await run({
    action: 'CloseWnd',
  })
  return {
    originResult,
  }
})

/**
 * 历史版本比对
 * @param {array} compareArray 需要进行比对的源数据
 */
export const compareFile = wrap({ minVer: '*' }, async compareArray => {
  const originResult = await run({
    action: 'CompareFile',
    params: JSON.stringify({ remotePaths: compareArray }),
  })
  return {
    originResult,
  }
})

/**
 * 获取登录信息
 */
export const readLastLoginInfo = wrap({ minVer: '*' }, async () => {
  const originResult = await run({
    action: 'ReadLastLoginInfo',
  })
  return {
    originResult,
  }
})

/**
 * 登录成功
 * @param {string} session 登录成功后返回的sessionid
 * @param {string} s 种植的cookie S
 */
export const loginOk = wrap({ minVer: '*' }, async ({ session, s }) => {
  const originResult = await run({
    action: 'LoginOk',
    params: JSON.stringify({
      session,
      s,
    }),
  })
  return {
    originResult,
  }
})

/**
 * 刷新页面
 */
export const refresh = wrap({ minVer: '*' }, async () => {
  const originResult = await run({
    action: 'Refresh',
  })
  return {
    originResult,
  }
})

/**
 * 客户端登录页设置窗口
 */
export const showLoginSettingWnd = wrap({ minVer: '*' }, async () => {
  const originResult = await run({
    action: 'ShowLoginSettingWnd',
  })
  return {
    originResult,
  }
})

/**
 * 客户端登录页最小化窗口
 */
export const minWnd = wrap({ minVer: '*' }, async () => {
  const originResult = await run({
    action: 'MinWnd',
  })
  return {
    originResult,
  }
})

/**
 * 打开第三方登录窗口
 *  @param {string} url 窗口中显示页面的链接
 */
export const openThirdLoginWnd = wrap({ minVer: '*' }, async ({ url }) => {
  const originResult = await run({
    action: 'OpenThirdLoginWnd',
    params: JSON.stringify({
      url,
    }),
  })
  return {
    originResult,
  }
})

/**
 * 获取企业微信登录结果接口
 *  @param {string} session 登录成功后返回的 X-LENOVO-SESS-ID
 *  @param {string} s 登录成功后返回的 S
 *  @param {boolean}  isBindLogin 是否是首次绑定登录
 */
export const thirdLoginOk = wrap({ minVer: '*' }, async ({ session, s, isBindLogin }) => {
  const originResult = await run({
    action: 'ThirdLoginOk',
    params: JSON.stringify({
      is_bind_login: isBindLogin,
      session,
      s,
    }),
  })
  return {
    originResult,
  }
})
